import { useAtomValue } from 'jotai'
import { isDoctolibLoaded } from '../../../state/doctolib'
import { useGetPatient } from '../../queries/patients'
import { useCallback, useEffect, useState } from 'react'
import { isDefined } from '../../../misc/functions.utilities'
import { doctolibZipperOpenPatientHistoric } from '../../../misc/Doctolib/doctolib.actions'

export const useOpenPatientHistoric = () => {
  const isZipperLoaded = useAtomValue(isDoctolibLoaded)
  const [patientId, setPatientId] = useState<number | null>(null)
  const {
    query: { data: patient },
  } = useGetPatient({ id: patientId!, enabled: isDefined(patientId) && isZipperLoaded })

  useEffect(() => {
    if (patient) {
      console.log(`Doctolib: Open historic for patient with id ${patient.id}`)
      doctolibZipperOpenPatientHistoric(patient)
      setPatientId(null)
    }
  }, [patient])

  const triggerOpenPatientHistoric = useCallback(
    ({ patientId }: { patientId: number }) => {
      setPatientId(isZipperLoaded ? patientId : null)
    },
    [isZipperLoaded],
  )

  return { triggerOpenPatientHistoric }
}
